export default __webpack_public_path__ + "static/media/cubi-animated.86e16168.gif";